import { httpService } from 'services/HttpServices';
import { getEndPoint } from 'config/Config';

export const getGoogleId = () => {
	const completePath = getEndPoint() + '/google-tag/';
	return httpService.request('get', completePath, {});
};
